webpackJsonp([34],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(1);
	
	var _reactDom = __webpack_require__(192);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _configureStore = __webpack_require__(359);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _reducers = __webpack_require__(576);
	
	var _createRootRouter = __webpack_require__(753);
	
	var _createRootRouter2 = _interopRequireDefault(_createRootRouter);
	
	__webpack_require__(2207);
	
	__webpack_require__(1292);
	
	__webpack_require__(1979);
	
	__webpack_require__(2214);
	
	__webpack_require__(2216);
	
	var _screensTubeRouter = __webpack_require__(2234);
	
	var _screensTubeRouter2 = _interopRequireDefault(_screensTubeRouter);
	
	var _screensTubeReducers = __webpack_require__(679);
	
	var _screensTubeReducers2 = _interopRequireDefault(_screensTubeReducers);
	
	var _configs = __webpack_require__(424);
	
	var _utils = __webpack_require__(390);
	
	if (!window.Intl) {
	  __webpack_require__(2218);
	}
	if (!window.location.origin) {
	  (0, _utils.locationOrigin)();
	}
	
	var reducer = (0, _reducers.createRootReducer)('tube', _screensTubeReducers2['default']);
	var store = (0, _configureStore2['default'])(reducer, 'Tube', _configs.url.NEWTUBE_API_SERVER);
	var rootRouter = (0, _createRootRouter2['default'])(store, _screensTubeRouter2['default']);
	
	_reactDom2['default'].render(rootRouter, document.getElementById('root'));

/***/ },

/***/ 2234:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	var _screensDepartmentNewsRouter = __webpack_require__(2235);
	
	var _screensDepartmentNewsRouter2 = _interopRequireDefault(_screensDepartmentNewsRouter);
	
	var _screensCompanyNewsRouter = __webpack_require__(2354);
	
	var _screensCompanyNewsRouter2 = _interopRequireDefault(_screensCompanyNewsRouter);
	
	var _screensCompanyRulesRouter = __webpack_require__(2360);
	
	var _screensCompanyRulesRouter2 = _interopRequireDefault(_screensCompanyRulesRouter);
	
	var _screensInternalLinksRouter = __webpack_require__(2393);
	
	var _screensInternalLinksRouter2 = _interopRequireDefault(_screensInternalLinksRouter);
	
	var _screensLinksSettingRouter = __webpack_require__(2397);
	
	var _screensLinksSettingRouter2 = _interopRequireDefault(_screensLinksSettingRouter);
	
	var _screensStickyNotesRouter = __webpack_require__(2401);
	
	var _screensStickyNotesRouter2 = _interopRequireDefault(_screensStickyNotesRouter);
	
	var _screensCompanyAdminRouter = __webpack_require__(2437);
	
	var _screensCompanyAdminRouter2 = _interopRequireDefault(_screensCompanyAdminRouter);
	
	var _screensAssignmentTaskRouter = __webpack_require__(2450);
	
	var _screensAssignmentTaskRouter2 = _interopRequireDefault(_screensAssignmentTaskRouter);
	
	var _screensOrdersRouter = __webpack_require__(2473);
	
	var _screensOrdersRouter2 = _interopRequireDefault(_screensOrdersRouter);
	
	var _screensAccountSettingRouter = __webpack_require__(2537);
	
	var _screensAccountSettingRouter2 = _interopRequireDefault(_screensAccountSettingRouter);
	
	var _screensPeopleSearchRouter = __webpack_require__(2548);
	
	var _screensPeopleSearchRouter2 = _interopRequireDefault(_screensPeopleSearchRouter);
	
	var _screensCompanySpaceRouter = __webpack_require__(2579);
	
	var _screensCompanySpaceRouter2 = _interopRequireDefault(_screensCompanySpaceRouter);
	
	var _screensPrivacyRouter = __webpack_require__(2638);
	
	var _screensPrivacyRouter2 = _interopRequireDefault(_screensPrivacyRouter);
	
	var _screensGoogleOAuthPageRouter = __webpack_require__(2642);
	
	var _screensGoogleOAuthPageRouter2 = _interopRequireDefault(_screensGoogleOAuthPageRouter);
	
	var _containersAppComponentsEnsureLoggedIn = __webpack_require__(1938);
	
	var _containersAppComponentsEnsureLoggedIn2 = _interopRequireDefault(_containersAppComponentsEnsureLoggedIn);
	
	var _containersAppComponentsLayout = __webpack_require__(1943);
	
	var _containersAppComponentsLayout2 = _interopRequireDefault(_containersAppComponentsLayout);
	
	var _screensLoginPassRouter = __webpack_require__(2646);
	
	var _screensLoginPassRouter2 = _interopRequireDefault(_screensLoginPassRouter);
	
	var _screensVerificationRouter = __webpack_require__(2648);
	
	var _screensVerificationRouter2 = _interopRequireDefault(_screensVerificationRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  null,
	  _screensLoginPassRouter2['default'],
	  _react2['default'].createElement(
	    _reactRouter.Route,
	    { component: _containersAppComponentsLayout2['default'] },
	    _screensGoogleOAuthPageRouter2['default'],
	    _screensPrivacyRouter2['default'],
	    _screensVerificationRouter2['default'],
	    _react2['default'].createElement(
	      _reactRouter.Route,
	      { component: _containersAppComponentsEnsureLoggedIn2['default'] },
	      _react2['default'].createElement(
	        _reactRouter.Route,
	        { path: 'tube',
	          getComponent: function (location, cb) {
	            __webpack_require__.e/* nsure */(71, function (require) {
	              cb(null, __webpack_require__(2661));
	            });
	          }
	        },
	        _react2['default'].createElement(_reactRouter.IndexRoute, {
	          getComponent: function (location, cb) {
	            __webpack_require__.e/* nsure */(72, function (require) {
	              cb(null, __webpack_require__(2670));
	            });
	          }
	        }),
	        _screensDepartmentNewsRouter2['default'],
	        _screensCompanyNewsRouter2['default'],
	        _screensCompanyRulesRouter2['default'],
	        _screensInternalLinksRouter2['default'],
	        _screensLinksSettingRouter2['default'],
	        _screensStickyNotesRouter2['default'],
	        _screensAssignmentTaskRouter2['default'],
	        _screensCompanyAdminRouter2['default'],
	        _screensOrdersRouter2['default'],
	        _screensAccountSettingRouter2['default'],
	        _screensPeopleSearchRouter2['default'],
	        _screensCompanySpaceRouter2['default']
	      )
	    ),
	    _react2['default'].createElement(_reactRouter.Redirect, { from: '*', to: '/tube' })
	  )
	);
	module.exports = exports['default'];

/***/ },

/***/ 2235:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	var _screensAdminRouter = __webpack_require__(2236);
	
	var _screensAdminRouter2 = _interopRequireDefault(_screensAdminRouter);
	
	var _screensUserRouter = __webpack_require__(2345);
	
	var _screensUserRouter2 = _interopRequireDefault(_screensUserRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  {
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(37, function (require) {
	        cb(null, __webpack_require__(2353));
	      });
	    }
	  },
	  _screensAdminRouter2['default'],
	  _screensUserRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2236:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'departmentnews/management',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(35, function (require) {
	      cb(null, __webpack_require__(2237));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2345:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'departmentnews',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(36, function (require) {
	      cb(null, __webpack_require__(2346));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2354:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	var _screensAdminRouter = __webpack_require__(2355);
	
	var _screensAdminRouter2 = _interopRequireDefault(_screensAdminRouter);
	
	var _screensUserRouter = __webpack_require__(2357);
	
	var _screensUserRouter2 = _interopRequireDefault(_screensUserRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  { path: 'companynews',
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(40, function (require) {
	        cb(null, __webpack_require__(2359));
	      });
	    }
	  },
	  _screensAdminRouter2['default'],
	  _screensUserRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2355:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'management/:categoryId',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(38, function (require) {
	      cb(null, __webpack_require__(2356));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2357:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: ':categoryId',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(39, function (require) {
	      cb(null, __webpack_require__(2358));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2360:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	var _screensAdminRouter = __webpack_require__(2361);
	
	var _screensAdminRouter2 = _interopRequireDefault(_screensAdminRouter);
	
	var _screensUserRouter = __webpack_require__(2386);
	
	var _screensUserRouter2 = _interopRequireDefault(_screensUserRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  {
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(43, function (require) {
	        cb(null, __webpack_require__(2392));
	      });
	    }
	  },
	  _screensAdminRouter2['default'],
	  _screensUserRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2361:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'companyrules/management',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(41, function (require) {
	      cb(null, __webpack_require__(2362));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2386:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'companyrules',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(42, function (require) {
	      cb(null, __webpack_require__(2387));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2393:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'internallinks',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(44, function (require) {
	      cb(null, __webpack_require__(2394));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2397:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'links/setting',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(45, function (require) {
	      cb(null, __webpack_require__(2398));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2401:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	var _screensReceivedRouter = __webpack_require__(2402);
	
	var _screensReceivedRouter2 = _interopRequireDefault(_screensReceivedRouter);
	
	var _screensSendedRouter = __webpack_require__(2423);
	
	var _screensSendedRouter2 = _interopRequireDefault(_screensSendedRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  {
	    path: 'stickynotes',
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(48, function (require) {
	        cb(null, __webpack_require__(2431));
	      });
	    }
	  },
	  _screensReceivedRouter2['default'],
	  _screensSendedRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2402:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'received',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(46, function (require) {
	      cb(null, __webpack_require__(2403));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2423:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'sended',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(47, function (require) {
	      cb(null, __webpack_require__(2424));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2437:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  { path: 'admin',
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(49, function (require) {
	        cb(null, __webpack_require__(2438));
	      });
	    }
	  },
	  _react2['default'].createElement(_reactRouter.Route, {
	    path: 'orgimport',
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(50, function (require) {
	        cb(null, __webpack_require__(2446));
	      });
	    }
	  })
	);
	module.exports = exports['default'];

/***/ },

/***/ 2450:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	var _screensReceivedRouter = __webpack_require__(2451);
	
	var _screensReceivedRouter2 = _interopRequireDefault(_screensReceivedRouter);
	
	var _screensSendedRouter = __webpack_require__(2462);
	
	var _screensSendedRouter2 = _interopRequireDefault(_screensSendedRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  {
	    path: 'assignmenttask',
	    getComponent: function (Location, cb) {
	      __webpack_require__.e/* nsure */(53, function (require) {
	        cb(null, __webpack_require__(2470));
	      });
	    }
	  },
	  _screensReceivedRouter2['default'],
	  _screensSendedRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2451:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'received(/:assignmentId)',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(51, function (require) {
	      cb(null, __webpack_require__(2452));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2462:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'sended(/:assignmentId)',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(52, function (require) {
	      cb(null, __webpack_require__(2463));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2473:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	var _screensActiveRouter = __webpack_require__(2474);
	
	var _screensActiveRouter2 = _interopRequireDefault(_screensActiveRouter);
	
	var _screensEndRouter = __webpack_require__(2511);
	
	var _screensEndRouter2 = _interopRequireDefault(_screensEndRouter);
	
	var _screensStoreRouter = __webpack_require__(2516);
	
	var _screensStoreRouter2 = _interopRequireDefault(_screensStoreRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  {
	    path: 'orders',
	    getComponent: function (Location, cb) {
	      __webpack_require__.e/* nsure */(57, function (require) {
	        cb(null, __webpack_require__(2527));
	      });
	    }
	  },
	  _screensActiveRouter2['default'],
	  _screensEndRouter2['default'],
	  _screensStoreRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2474:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'active(/:orderingId)',
	  getComponent: function (Location, cb) {
	    __webpack_require__.e/* nsure */(54, function (require) {
	      cb(null, __webpack_require__(2475));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2511:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'end',
	  getComponent: function (Location, cb) {
	    __webpack_require__.e/* nsure */(55, function (require) {
	      cb(null, __webpack_require__(2512));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2516:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'store',
	  getComponent: function (Location, cb) {
	    __webpack_require__.e/* nsure */(56, function (require) {
	      cb(null, __webpack_require__(2517));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2537:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'AccountSetting',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(58, function (require) {
	      cb(null, __webpack_require__(2538));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2548:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	var _screensListScreensEmployeeRouter = __webpack_require__(2549);
	
	var _screensListScreensEmployeeRouter2 = _interopRequireDefault(_screensListScreensEmployeeRouter);
	
	var _screensListScreensDepartmentRouter = __webpack_require__(2565);
	
	var _screensListScreensDepartmentRouter2 = _interopRequireDefault(_screensListScreensDepartmentRouter);
	
	var _screensListScreensUnderDepartmentRouter = __webpack_require__(2569);
	
	var _screensListScreensUnderDepartmentRouter2 = _interopRequireDefault(_screensListScreensUnderDepartmentRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  {
	    path: 'peoplesearch'
	  },
	  _react2['default'].createElement(_reactRouter.IndexRoute, {
	    getComponent: function (Location, callback) {
	      __webpack_require__.e/* nsure */(62, function (require) {
	        callback(null, __webpack_require__(2573));
	      });
	    }
	  }),
	  _screensListScreensUnderDepartmentRouter2['default'],
	  _screensListScreensDepartmentRouter2['default'],
	  _screensListScreensEmployeeRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2549:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: '(:id)',
	  i18nCrumbKey: 'SH_EmployeeData',
	  i18nCrumbDefaultMessage: '員工資料',
	  getComponent: function (Location, callback) {
	    __webpack_require__.e/* nsure */(59, function (require) {
	      callback(null, __webpack_require__(2550));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2565:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'DepartmentId/(:departmentId)',
	  getComponent: function (Location, callback) {
	    __webpack_require__.e/* nsure */(60, function (require) {
	      callback(null, __webpack_require__(2566));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2569:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'employee/(:departmentId)',
	  getComponent: function (Location, callback) {
	    __webpack_require__.e/* nsure */(61, function (require) {
	      callback(null, __webpack_require__(2570));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2579:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	var _screensPermissionRouter = __webpack_require__(2580);
	
	var _screensPermissionRouter2 = _interopRequireDefault(_screensPermissionRouter);
	
	var _screensPermissionSearchRouter = __webpack_require__(2588);
	
	var _screensPermissionSearchRouter2 = _interopRequireDefault(_screensPermissionSearchRouter);
	
	var _screensSiteSettingRouter = __webpack_require__(2592);
	
	var _screensSiteSettingRouter2 = _interopRequireDefault(_screensSiteSettingRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  { path: 'companyspace',
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(66, function (require) {
	        cb(null, __webpack_require__(2635));
	      });
	    }
	  },
	  _screensPermissionRouter2['default'],
	  _screensPermissionSearchRouter2['default'],
	  _screensSiteSettingRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2580:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: 'permission',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(63, function (require) {
	      cb(null, __webpack_require__(2581));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2588:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: 'permissionsearch',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(64, function (require) {
	      cb(null, __webpack_require__(2589));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2592:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: 'sitesetting',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(65, function (require) {
	      cb(null, __webpack_require__(2593));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2638:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: 'privacy',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(67, function (require) {
	      cb(null, __webpack_require__(2639));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2642:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: 'google-auth-page',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(68, function (require) {
	      cb(null, __webpack_require__(2643));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2646:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: '/LoginPass',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(69, function (require) {
	      cb(null, __webpack_require__(2647));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2648:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(578);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(818);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: 'verification',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(70, function (require) {
	      cb(null, __webpack_require__(2649));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ }

});


/** WEBPACK FOOTER **
 ** tube.js
 **/